var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefaultAvatarLarge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f5f5f5;}.b{fill:none;stroke:#cccccd;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-width:10px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-923 -211)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 115,
    cy: 115,
    r: 115,
    transform: "translate(928 216)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(928 216)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M93.753,106.23c-1.42-24.987-15.668-32.918-36.5-39.862-14.9-4.968-19.7-20.019-21.239-29.2",
    transform: "translate(94.322 97.551)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M70.76,37.161c-1.542,9.189-6.319,24.247-21.22,29.215C28.7,73.32,14.325,81.147,12.9,106.142",
    transform: "translate(28.886 97.543)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M60.366,106.077h0A38.365,38.365,0,0,1,22,67.712V52.366A38.365,38.365,0,0,1,60.366,14h0A38.365,38.365,0,0,1,98.731,52.366V67.712A38.365,38.365,0,0,1,60.366,106.077Z",
    transform: "translate(54.634 31.974)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 115,
    cy: 115,
    r: 115
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAvatarLarge);
export default __webpack_public_path__ + "static/media/default-avatar-large.1afcf9beb42e4a677390e71ebe5ffd37.svg";
export { ForwardRef as ReactComponent };